//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mapUtil from '@/javascript/mapUtil'
import EsQuery from '@/javascript/esQuery'
import Swiper from 'swiper'
import util from '@/javascript/util'
import loading from '@/components/public-components/loading/index.vue'
import goBack from '@/components/public-components/goBack/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

export default {
  components: {
      loading,
      goBack,
      Footer
  },
  data () {
    return {
      hotelList: [],
      commentList: [],
      location: {},
      pageNo: 0,
      pageSize: 10,
      infiniteAll: false,
      infiniteStatus: false,
      isShow: false,
      minHeight: 0
    }
  },
  mounted () {
    this.minHeight = document.documentElement.clientHeight
    document.title = '酒店住宿'
    this.getCommentList()
    // mapUtil.locate((data) => {
    //   this.locationResult(data);

    // }, (data) => {
    //   this.locationResult(data);
    // })
    this.getHotelList()

    /**
      * 微信签名分享
      */
    if (util.isWeiXin()) {
      const shareData = typeof (shareData) === 'undefined' ? {
        title: this.PAGE_TITLE + "导览",
        desc: '圣湖之光，大景海晏，海晏欢迎您~~',
        imgUrl: window.location.origin + '/static/-img/banner_img.png',
        link: window.location.href
      } : shareData;
      this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
        util.initWxConfig(response.data.data, shareData)
      })
    }

  },

  methods: {
    locationResult (val) {
      this.location = val
      this.getHotelList()
    },

    //监听滚动
    windowScroll (e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 0) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      // 底部加载
      if (util.pullUpLoad()) {
        this.infinite()
      }
    },

    infinite: function () {
      if (this.infiniteAll) {
        return
      }
      if (this.infiniteStatus) {
        return
      }
      if (this.hotelList.length == 0) {
        return
      }
      this.infiniteStatus = true
      this.pageNo++
      this.getHotelList()
    },

    // 推荐酒店
    getCommentList () {

      const _this = this
      const querystring = require('querystring');
      const houseEsQuery = new EsQuery()
      houseEsQuery
        //   .addStartWith("category", _this.XXCJ_TYPE_CODE.JD, houseEsQuery.and, false)
        .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, houseEsQuery.and, false)
        .addString('tags', '推荐', houseEsQuery.and, false)
        .addSort("weight", houseEsQuery.desc, false)
        .addPage(0, 100)
      const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray())
      _this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
        indexName: _this.INDEX_NAME_TYPE.hotelList,
        esJsonQuery: houseEsJsonQuery
      })).then(function (res) {
        window.addEventListener('scroll', _this.windowScroll) // 监听滚动
        const data = res.data.data
        let commentList = data.filter(item => item._source.score != '0.00')
        _this.commentList = commentList.map(item => item._source)
        _this.$nextTick(() => {
          new Swiper('.the-recommend-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 20,
            initialSlide: 0,
          })
        })
        // _this.commentList = _this.commentList.slice(3,6)
      })
    },
    // 酒店列表
    getHotelList () {
      const _this = this
      const querystring = require('querystring');
      const houseEsQuery = new EsQuery()
      houseEsQuery
        // .addStartWith("category", _this.XXCJ_TYPE_CODE.JD, houseEsQuery.and, false)
        // .addSort("level", houseEsQuery.asc, false)
        .addStartWith("deptCode", _this.DEPT_CODE.DEPTCODE, houseEsQuery.and, false)
        .addPage(_this.pageNo * _this.pageSize, _this.pageSize)
      const houseEsJsonQuery = JSON.stringify(houseEsQuery.getArray())
      _this.$http.post('/api/wtcp-kb/pub/doc/search', querystring.stringify({
        indexName: _this.INDEX_NAME_TYPE.hotelList,
        esJsonQuery: houseEsJsonQuery
      })).then(function (res) {
        let data = []
        data = res.data.data.map(item => {
          item._source.distance = _this.location.position ? mapUtil.getDistance(_this.location.position.lng, _this.location.position.lat, item._source.longitude, item._source.latitude) : ''
          return item._source
        })
        // _this.hotelList = []
        _this.hotelList = _this.hotelList.concat(data)
        _this.$set(_this, "hotelList", _this.hotelList);
        if (res.data.data.length < _this.pageSize) {
          _this.infiniteAll = true
        }
        _this.infiniteStatus = false
      })
    },

  },
}
